import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import "./ModelSettings.css";
import ModelParameter from "./ModelParameter";
import { ModelsNamesCompany } from "../../../../Helper";
import { ModelParameters } from "../../../../store/one-query/modelsettings";
import { setShowSignPopup, setSnackBarAlert } from "../../../../store/one-query/chatsSlice";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
interface ModelSettingsProps {
  show: boolean;
  handleClose: () => void;
}
const ModelSettings: React.FC<ModelSettingsProps> = ({ show, handleClose }) => {
  const navigate = useNavigate();
  const modelParameters = useAppSelector(
    (s) => s.ModelSettings.modelParameters
  );
  const [filteredModelParameters, setFilteredModelParameters] = useState<
    ModelParameters[]
  >([]);
  const dispatch = useAppDispatch();
  const DataVersionsStore = useAppSelector((s) => s?.conversationVersion?.data);
  const [selectedModel, setSelectedModel] = useState<string>();
  const { Chat1Data, Chat2Data, Chat3Data, Chat4Data, Chat5Data, Chat6Data } =
    useAppSelector((state) => state.ChatsState);
  const [modelsIds, setModelsIds] = useState<string[]>();
  const [applyallModels, setApplyallModels] = useState(false);
  const isFirstRender = useRef(true);
  const params = selectedModel
     ? modelParameters.find((item) => Object.keys(item)[0] === selectedModel)?.[
         selectedModel
       ]
     : undefined;
  const User=useAppSelector((s)=>s.User);
  const disabledVersions = useAppSelector((s) => s.ChatsState.disabledVersions);
  useEffect(() => {
    setModelsIds([
      Chat1Data?.id,
      Chat2Data?.id,
      Chat3Data?.id,
      Chat4Data?.id,
      Chat5Data?.id,
      Chat6Data?.id,
    ]);
  }, [
    Chat1Data?.id,
    Chat2Data?.id,
    Chat3Data?.id,
    Chat4Data?.id,
    Chat5Data?.id,
    Chat6Data?.id,
  ]);

  // When the user opens the popup for the first time, select the first item in filteredModelParameters
  useEffect(() => {
    if (isFirstRender.current && filteredModelParameters?.length > 0) {
      setSelectedModel(Object.keys(filteredModelParameters[0])[0]);
      isFirstRender.current = false; // Reset after first render
    }
  }, [filteredModelParameters]);

 useEffect(() => {
   const objData = modelsIds
     ?.map((objId) => {
       const version = DataVersionsStore?.find(
         (version) => version?.id === objId
       );
       return version;
     })
     .filter(Boolean); // Filter out null values
   if (objData && objData.length > 0) {
     // Sort objData based on disabledVersions
     const sortedObjData = [...objData].sort((a: any, b: any) => {
       const indexA = disabledVersions.indexOf(a.id);
       const indexB = disabledVersions.indexOf(b.id);

       if (indexA !== -1 && indexB !== -1) {
         return indexA - indexB;
       }
       if (indexA !== -1) return -1;
       if (indexB !== -1) return 1;
       return 0;
     });
     // Generate keys based on sortedObjData
     const createModelSettingsKeys = sortedObjData.map((version) => {
      if(version)
       return (
         ModelsNamesCompany[version.name.toLowerCase()] + " & " + version.title
       );
     });
     // Filter and sort modelParameters based on createDataKeys
     const filtered = modelParameters
       ?.filter((item) => {
         const key = Object.keys(item)[0]; // Extract key from each object
         return createModelSettingsKeys.includes(key); // Filter items matching createDataKeys
       })
       .sort((a, b) => {
         const keyA = Object.keys(a)[0];
         const keyB = Object.keys(b)[0];
         return (
           createModelSettingsKeys.indexOf(keyA) -
           createModelSettingsKeys.indexOf(keyB)
         ); // Sort by createDataKeys order
       });
     setFilteredModelParameters(filtered);
   }
 }, [modelsIds, disabledVersions, modelParameters]);
  const handleSelectModel = (key: string) => {
    setSelectedModel(key);
    setApplyallModels(false);
  };
  const handleReturnDefaultParameter = () => {
     if(!User.IsAuthenticated){
      handleClose();
      dispatch(setShowSignPopup({show: true , type: "Model settings" , message: "To edit in model settings you need to sign in ",btnTitle:"Sign In for Free",btnAction:"NavigateToLogin"}));
    }
    else{
    setApplyallModels(false);
    dispatch(
      setSnackBarAlert({
        show: true,
        message: "Model settings have been successfully reset",
        alertType: "success",
      })
    );
  }
  };
  const ResetApplyAllModels = (flag: boolean) => {
    setApplyallModels(flag);
  };
  const handleClosePopUp = () => {
    handleClose();
    setApplyallModels(false);
  };
  return (
    <Modal
      className="DeleteModal"
      show={show}
      centered
      dialogClassName="custom-modal-dialog"
    >
      <Modal.Header className="modelSettingsPopupHeader border-0">
        <Modal.Title className="settingPopupHeader">Model settings</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`SettingModalBody border-0 px-2 rounded-bottom-4 py-0`}>
        <div className="row">
          <div className="col-4 model-data-container ">
            <Box>
              
            {filteredModelParameters?.map((item: any, index: number) => {
              const key = Object.keys(item)[0]; // Get the single key from the object
              const [modelName, title] = key.split(" & "); // Split the key to get modelName and title
              return (
                <div
                  key={index}
                  className={`model-item-Conatiner c-pointer ${
                    selectedModel === key ? "selected-model" : ""
                  }`}
                  onClick={() => handleSelectModel(key)} // Pass key and params to the handler
                >
                  <div
                    className={`company-name-model ${
                      selectedModel === key ? "selected-modelName" : ""
                    }`}
                  >
                    {modelName}
                  </div>
                  <div
                    className={`version-name-model ${
                      selectedModel === key ? "selected-modelName" : ""
                    }`}
                  >
                    {title}
                  </div>
                </div>
              );
            })}
            </Box>
            <div
              className="reset-all c-pointer"
              onClick={handleReturnDefaultParameter}
            >
              Reset all
            </div>
          </div>
          <div className="col-8 parameter-conatiner">
            {selectedModel && (
              <ModelParameter
                selectedModel={selectedModel}
                params={params}
                ResetApplyAllModels={ResetApplyAllModels}
                applyallModels={applyallModels}
                handleClose={handleClose}
              />
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModelSettings;
